import React from 'react';
import { Grid, Box, Typography, useTheme } from '@quillbot/design-system';
// import { getImagePath } from 'src/_common/components/ImageContainer';

interface IProps {
  classes: Record<string, string>;
}

function SalesSteps(props: IProps) {
  const theme = useTheme();
  const publicFolderURL = `images/theme/${theme.palette.mode}/affiliatePage`;
  const salesSteps = [
    {
      image: 'affiliateSignUp.png',
      header: '1. Sign Up',
      description: 'Sign up in less than a minute',
    },
    {
      image: 'affiliateShare.png',
      header: '2. Share',
      description: 'Share a URL with your network',
    },
    {
      image: 'affiliateMoneyBag.png',
      header: '3. Earn',
      description: 'Earn big in multiple ways',
    },
  ];
  return (
    <>
      {salesSteps.map((ele) => (
        <Grid item xs={12} md={3} className={props.classes.textCenter} key={ele.image}>
          <Box mt={5}>
            <img
              src={`${publicFolderURL}/${ele.image}`}
              className={props.classes.fluidImage}
              height="116px"
              alt={ele.description}
            />
            <Box mt={2}>
              <Typography
                style={{ fontWeight: 'bold' }}
                align="center"
                variant="h6"
                className={`${props.classes.font21} ${props.classes.titleContent} `}
              >
                {ele.header}
              </Typography>
            </Box>
            <Typography
              paragraph
              align="center"
              variant="body1"
              className={props.classes.affiliateDescription}
            >
              {ele.description}
            </Typography>
          </Box>
        </Grid>
      ))}
    </>
  );
}

export default SalesSteps;
